/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, effect, input, output } from '@angular/core';
import {
  PickList,
  PickListMoveAllToSourceEvent,
  PickListMoveAllToTargetEvent,
  PickListMoveToSourceEvent,
  PickListMoveToTargetEvent
} from 'primeng/picklist';

@Component({
  selector: 'app-picklist',
  imports: [PickList],
  templateUrl: './picklist.component.html',
  styleUrl: './picklist.component.scss'
})
export class PicklistComponent<T = any> {
  public readonly bindLabel = input<string>();
  public readonly bindValue = input<string>();
  public readonly disabled = input<boolean>(false);
  public readonly items = input.required<T[]>();
  public readonly pickedItems = input.required<T[]>();
  public readonly itemsPicked = output<string[]>();
  public readonly itemsUnpicked = output<string[]>();

  protected sourceItems: T[] = [];
  protected targetItems: T[] = [];

  constructor() {
    effect(() => {
      this.items();
      this.pickedItems();
      this.syncLists();
    });
  }

  protected onMoveToTarget(event: PickListMoveToTargetEvent): void {
    this.itemsPicked.emit(this.mapToValues(event.items));
    this.syncLists();
  }

  protected onMoveAllToTarget(event: PickListMoveAllToTargetEvent): void {
    this.itemsPicked.emit(this.mapToValues(event.items));
    this.syncLists();
  }

  protected onMoveToSource(event: PickListMoveToSourceEvent): void {
    this.itemsUnpicked.emit(this.mapToValues(event.items));
    this.syncLists();
  }

  protected onMoveAllToSource(event: PickListMoveAllToSourceEvent): void {
    this.itemsUnpicked.emit(this.mapToValues(event.items));
    this.syncLists();
  }

  public getItemLabel(item: any): string {
    const bindLabel = this.bindLabel();
    return bindLabel ? item[bindLabel] : item;
  }

  private mapToValues(items: any[]): string[] {
    return items.map((item: any) => {
      const bindValue = this.bindValue();
      return (bindValue ? item[bindValue] : item);
    });
  }

  private syncLists(): void {
    this.sourceItems = [...this.items()];
    this.targetItems = [...this.pickedItems()];
  }
}